import { mapUnitOptionsToSelectOptions } from './mapUnitOptionsToSelectOptions';
import { resolveUnitId } from './resolveUnitId';

/**
 * 依 `defaultDisplayUnit` 偏好選預設單位：
 * - `CONVERT`：優先非 base（進位）單位，無則退回 base
 * - 其餘／缺省：優先 baseUnit===true，否則第一筆，否則 ''
 *
 * @param {Array<object>|null|undefined} selectOptionsOrUnitOptions
 * @param {{ defaultDisplayUnit?: string|null }} [options]
 * @returns {string}
 */
export function pickDefaultUnitId(selectOptionsOrUnitOptions, options = {}) {
  const list = Array.isArray(selectOptionsOrUnitOptions)
    ? selectOptionsOrUnitOptions
    : [];
  if (list.length === 0) {
    return '';
  }

  const looksLikeSelect = list.some(
    (row) => row && Object.prototype.hasOwnProperty.call(row, 'value'),
  );
  const selectOptions = looksLikeSelect
    ? list
    : mapUnitOptionsToSelectOptions(list);

  const preferConvert = options.defaultDisplayUnit === 'CONVERT';
  if (preferConvert) {
    const convert = selectOptions.find((row) => row?.baseUnit === false);
    if (convert?.value) {
      return String(convert.value);
    }
  }

  const base = selectOptions.find((row) => row?.baseUnit === true);
  if (base?.value) {
    return String(base.value);
  }

  const first = selectOptions[0];
  if (first?.value) {
    return String(first.value);
  }

  return resolveUnitId(first) || '';
}
